import React from 'react';

const letters = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z'
];

const LettersBar = () => (
  <div className="index-container">
    <ul>
      {letters.map(letter => (
        <li key={letter}>
          <a href={`#${letter}`}>{letter}</a>
        </li>
      ))}
    </ul>
  </div>
);

export default LettersBar;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/LettersBar/LettersBar.js